import InputTest from './components/udesk-Input-Test.vue'

// 导出模块
export default InputTest

//global 情况下 自动安装
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('input-test', InputTest)
}



// WEBPACK FOOTER //
// ./src/index.js